<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw" :class="[post.poll_type ? 'fa-poll-people' : 'fa-bullhorn', {'fas': active, 'far': !active}]"></i></template>
        <template v-slot:content>
            <div class="tile-title preview">{{ preview }}</div>
            <div class="meta"><i class="far fa-fw fa-user mr-2"></i>{{ post.author_name }}</div>
            <div class="meta"><i class="far fa-fw fa-calendar-alt mr-2"></i>{{ post.created_at | moment('MMM Do, h:mma') }}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat" v-if="post.hidden"><i class="far fa-eye-slash" style="color:red"></i></span>
                <span class="stat" v-if="post.poll_type"><i class="far fa-poll-people"></i>{{ post.voter_count }}</span>
                <span class="stat" v-if="pollClosed"><b-tag class="stat"><i class="fas fa-lock mr-1"></i>Closed</b-tag></span>
                <span class="stat" v-if="post.reaction_count"><i class="far fa-heart"></i>{{ post.reaction_count }}</span>
                <span class="stat" v-if="post.comment_count"><i class="far fa-comment"></i>{{ post.comment_count }}</span>
                <span class="stat" v-if="post.announcement_type === 'schedule'"><b-tag type="is-warning" class="stat"><i class="fas fa-calendar-exclamation mr-1"></i>Schedule</b-tag></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="details-rollout">
                <toolbar class="toolbar">
                    <b-tooltip label="Edit/Replies">
                        <button class="icon-only" @click.stop="$openCard('edit-announcement', {tripId: post.trip_id, postId: post.id}, card)"><i class="far fa-pencil"></i></button>
                    </b-tooltip>
                    <b-tooltip label="Poll Results" v-if="post.poll_type">
                        <button class="icon-only" @click.stop="$openCard('announcement-results', {tripId: post.trip_id, postId: post.id}, card)"><i class="far fa-chart-bar"></i></button>
                    </b-tooltip>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="ID">{{ post.id }}</data-row>
                    <data-row mini title="Created">{{ post.created_at | moment('MM/DD/YYYY h:mma') }}</data-row>
                    <data-row mini title="Type">{{ post.announcement_type === 'schedule' ? 'Schedule update' : 'General' }}</data-row>
                    <data-row mini title="In Navigator">{{ post.hidden ? 'Hidden' : 'Everyone' }}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "../TIER/components/Toolbar";
    import DataRow from "../TIER/components/DataRow";
    import CardListItem from "../TIER/components/CardListItem";

    export default {
        name: 'AnnouncementListItem',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            post: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            pollClosed: function () {
                return !!this.post.poll_closes_at && new Date(this.post.poll_closes_at).getTime() <= Date.now();
            },
            // Roger announcement bodies are Quill HTML — the tile wants text.
            preview: function () {
                const text = (this.post.body || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
                return text || '(poll only)';
            }
        }
    }
</script>

<style lang="scss" scoped>
    li {
        color: darken($t-primary, 10);

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .preview {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 100%;
        }

        padding: 0.5rem 0;

        .details-rollout {
            margin-top: 0.5rem;
        }
    }
</style>
